<template>
	<div>
		<main>
			<section class="hero hero--job">
				<div class="container">
					<div class="hero__wrapper hero__wrapper--centered">
						<h1 class="hero__primary">Available Jobs</h1>
						<p class="hero__secondary pt-20"> Latest available jobs to help you achieve your dreams</p>
						<div class="form__inline">
							<input class="form__input form__input--inline" type="text"
							placeholder="Search for your dream job" v-model="query" v-on:keyup.enter="searchJobs">
							<button class="btn--inline btn__primary btn__primary--alt" @click.enter="searchJobs">Find Jobs</button>
						</div>
					</div>  
				</div>
			</section>
			<template v-if="loadingJobs">
				<div class="loading">
					<loader />
				</div>
			</template>
		
            <template v-else>
                <section class="section bg-grey">
						<h6 class="section__secondary">Recommended jobs based on your career interest</h6>
						<div class="container">
							<section class="main__grid boards">
                                <template v-if="filteredJobs && filteredJobs.length > 0">
                                    <main>
                                        <h3 class="section__title">Total numbers of Jobs available - {{ filteredJobs.length }}</h3>
                                        <ul class="">
                                            <li
                                                class="boards__item new"
                                                v-for="job in filteredJobs"
                                                :key="job.id"
                                                >
                                                <div class="item__row">
                                                    <div class="boards__detail">
                                                        <h5 class="bold">
                                                            <router-link :to="{
                                                                name: 'job-detail',
                                                                params: { id: job.id }}">
                                                                {{ job.title }}
                                                            </router-link>
                                                        </h5>
														<template v-if="job.user !== undefined">
															<span>{{ job.user.company.business_name  }}</span>
														</template>
                                                    </div>
                                                </div>
                                                <div class="right">
                                                    <ul class="tag">
                                                        <li class="tag__item">{{ job.type }}</li>
                                                    </ul>
                                                    <div class="boards__item__meta">
                                                        <span class="item">
                                                            <svg width="11" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 0A5.52 5.52 0 0 0 0 5.5C0 8.53 2.48 11 5.5 11 8.53 11 11 8.53 11 5.5 11 2.48 8.53 0 5.5 0zm0 9.63A4.14 4.14 0 0 1 1.37 5.5 4.14 4.14 0 0 1 5.5 1.37 4.14 4.14 0 0 1 9.63 5.5 4.14 4.14 0 0 1 5.5 9.63zm.17-6.88h-.86v3.14L7.8 7.56l.46-.68-2.58-1.41V2.75z" fill="#333" fill-opacity=".9"/>
                                                            </svg>
                                                            <span>
                                                                {{ job.created_at | date }}
                                                            </span>
                                                        </span>
                                                        <span class="item">
                                                            <svg width="8" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.77 0 0 1.7 0 3.85 0 6.71 4 11 4 11s4-4.29 4-7.15A3.9 3.9 0 0 0 4 0zm0 5.22c-.8 0-1.43-.6-1.43-1.37 0-.77.63-1.38 1.43-1.38.8 0 1.43.61 1.43 1.38 0 .77-.63 1.37-1.43 1.37z" fill="#474747"/>
                                                            </svg>
                                                            <span>
                                                                {{ job.location }}
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </main>
                                </template>
                                <template v-else-if="filteredJobs">
                                    <main>
                                        <h3 class="section__title">
                                            No jobs were found.
                                        </h3>
                                    </main>
                                </template>
                                <template v-else>
                                    <main>
                                        <h3 class="section__title">
                                            There was an error fetching jobs.
                                        </h3>
                                    </main>
                                </template>
								<aside>
									<h6 class="bold">Job Location</h6>
									<div class="boards__section">
										<select class="boards__input custom-select" name="" id="" v-model="selected" @change="jobFilter(selected)">
											<option v-for="option in options" v-bind:value="option.value" :key="option.value">
                                                {{ option.text }}
                                            </option>
										</select>
									</div>

									<h6 class="bold">Job Type</h6>
									<div class="boards__section">
										<ul class="panel">
											<li class="panel__item">Full time 
												<label class="check">
													<input name="radio" type="radio" @click="jobFilter('full-time')">
													<span class="checkmark"></span>
												</label>
											</li>
											<li class="panel__item">Contract 
												<label class="check">
													<input name="radio" type="radio" @click="jobFilter('contract')">
													<span class="checkmark"></span>
												</label>
											</li>
										</ul>
									</div>
								</aside>
							</section>
						</div>
				</section>
			</template>
		</main>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getJobList, searchJobs } from '../../utils/api/job';
import Loader from '../../components/Loader';
import states from './locations';
import { success } from '../../utils/toast';

export default {
	name: 'Jobs',
	data() {
		return {
			loadingJobs: true,
			jobsLoaded: false,
			jobs: [],
			checkedValue: '',
			query: '',
			options: states,
			selected: '',
			selectedValue: ''
		};
	},
	mounted() {
		if (this.userObject.is_credential_uploaded !== 1) {
			success({
				title: 'Notice!',
				text: 'Kindly update your credentials to proceed, you are being redirected.',
				timer: 8000
			});
			setTimeout(() => {
				this.$router.push({ name: 'user-profile', params: { id: this.$session.get('id') } });
			}, 5000);
		} else if (this.userObject.is_psychometric_completed !== 1) {
			success({
				title: 'Notice!',
				text: 'Kindly complete your psychometric tests to continue, you are being redirected.',
				timer: 8000
			});
			setTimeout(() => {
				this.$router.push({ name: 'test' });
			}, 5000);
		}
	},
	created() {
		this.getJobsList();
	},
	methods: {
		getJobsList() {
			getJobList(this.userObject.career.career_id)
				.then((response) => {
					if (response.status === 200) {
						this.jobs = response.data.data;
						this.jobsLoaded = true;
						return true;
					}
					this.jobsLoaded = false;
					return false;
				}).catch((error) => {
					this.jobsLoaded = false;
					return error;
				}).finally(() => {
					this.loadingJobs = false;
				});
		},
		jobFilter(value) {
			this.checkedValue = value;
		},
		searchJobs() {
			searchJobs(this.selected || this.query)
				.then((response) => {
					if (response.status === 200) {
						this.jobs = response.data.data;
						this.jobsLoaded = true;
						return true;
					}
					this.jobsLoaded = false;
					return false;
				}).catch((error) => {
					this.jobsLoaded = false;
					return error;
				}).finally(() => {
					this.loadingJobs = false;
				});
			return true;
		}
	},
	filters: {
		date(value) {
			return moment(value).fromNow();
		}
	},
	components: {
		Loader
	},
	computed: {
		...mapGetters([
			'userObject'
		]),
		filteredJobs() {
			if (this.checkedValue !== '') {
				return this.jobs.filter(job => job.type === this.checkedValue || job.location === this.checkedValue);
			}
			return this.jobs;
		}
	},
	watch: {
		selected() {
			this.searchJobs(this.selected);
		}
	}
};
</script>

<style lang="scss" scoped>
.job__heading.item {
	display: block;
}
.loading {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 50vh;
}
</style>

